// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-76b54547]{display:none}.product__upsellProducts[data-v-76b54547] .native-carousel__content .carousel-wrapper__slide--custom{margin-right:8px}@media(min-width:1024px){.product__upsellProducts[data-v-76b54547] .native-carousel__content .carousel-wrapper__slide--custom{margin-right:5px;padding-right:8px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
